var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgIconLineCheck = function SvgIconLineCheck(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 24,
    height: 24,
    viewBox: "0 0 24 24"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "m19.801 5.035 1.398 1.43L9.492 17.906l-6.699-6.699 1.414-1.414 5.301 5.3z"
  })));
};
export { SvgIconLineCheck as ReactComponent };
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMjQiIGhlaWdodD0iMjQiIHZpZXdCb3g9IjAgMCAyNCAyNCIgeG1sbnM9Imh0dHA6Ly93d3cudzMub3JnLzIwMDAvc3ZnIj4KPHBhdGggZD0iTTE5LjgwMTIgNS4wMzQ2N0wyMS4xOTkgNi40NjUwNEw5LjQ5MiAxNy45MDZMMi43OTI5NyAxMS4yMDdMNC4yMDcxOCA5Ljc5Mjc1TDkuNTA4MDggMTUuMDkzNEwxOS44MDEyIDUuMDM0NjdaIi8+Cjwvc3ZnPgo=";